export const tabs = ["pending", "processed"];
